module.exports = __webpack_public_path__ + "img/jixu.7d96ae4e.png";